import * as React from 'react';
import { render } from 'react-dom';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import ThemeProvider from './context/ThemeProvider';
import ThemeSelection from './components/ThemeSelection';
import Landing from './pages/Landing';
import BlogIndex from './pages/BlogIndex';
import BlogPost from './pages/BlogPost';

render(
    <React.StrictMode>
        <ThemeProvider>
            <BrowserRouter>
                <div className="min-h-screen bg-paper-50 text-ink-900 dark:bg-night-900 dark:text-ink-50 font-sans antialiased selection:bg-accent/20 selection:text-accent-deep dark:selection:text-accent-soft">
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/journal" element={<BlogIndex />} />
                        <Route path="/journal/:slug" element={<BlogPost />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                    <ThemeSelection />
                </div>
            </BrowserRouter>
        </ThemeProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);
